// extracted by mini-css-extract-plugin
module.exports = {"signup-alert":"layout-module__signup-alert___2YjSN","sg-icon-check-circle":"layout-module__sg-icon-check-circle___14zcp"};